import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { abortController } from 'store/utils';
import filtersStore from 'store/filters';
import measurementsStore from 'store/measurements';
import { getDistrictsApi, getDistrictApi, createDistrictApi, editDistrictApi, deleteDistrictApi, getDistrictDevelopersApi, getDistrictImagesApi, getDistrictCompaniesAggregate, getDistrictAdminApi, } from './api';
const initialState = {
    districts: [],
    district: {
        data: undefined,
        developers: [],
        images: [],
    },
    selected: undefined,
};
const actions = {
    setSelected: async (district, { setState }) => {
        setState((state) => {
            if (state.selected?.id !== district?.id) {
                state.selected = district;
                state.district = {};
            }
        });
    },
    getDistricts: async (params, { setState }) => {
        try {
            const { data: res } = await getDistrictsApi(params);
            setState((state) => { state.districts = res; });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error;
        }
    },
    getDistrictAdmin: async (id, { setState }) => {
        try {
            const { data: res } = await getDistrictAdminApi(id);
            setState((state) => { state.district.data = res; });
            return res;
        }
        catch (error) {
            //  @ts-ignore
            throw error;
        }
    },
    getDistrict: async (id) => {
        try {
            const filters = filtersStore.getState().filtersData;
            const { priceMeasurement, squareMeasurement } = measurementsStore.getState();
            const params = {
                ...filters,
                areaUnit: squareMeasurement,
                currencyCode: priceMeasurement,
            };
            const { data: res } = await getDistrictApi({ id, params });
            return res;
        }
        catch (err) {
            const error = err;
            throw error.response?.data ?? error;
        }
    },
    createDistrict: async (district, { setState }) => {
        // eslint-disable-next-line no-useless-catch
        try {
            const { data: res } = await createDistrictApi(district);
            setState((state) => {
                state.districts = state.districts.filter(({ id }) => id !== district?.id);
                state.districts.push(res);
            });
            return res;
        }
        catch (error) { // eslint-disable-line @typescript-eslint/no-explicit-any
            // @ts-ignore
            throw error;
        }
    },
    addDistrict: async (district, { setState }) => {
        try {
            setState((state) => { state.districts.push(district); });
        }
        catch (error) {
            // @ts-ignore
            throw error;
        }
    },
    editDistrict: async (district, { setState }) => {
        // eslint-disable-next-line no-useless-catch
        try {
            const { data: res } = await editDistrictApi(district);
            setState((state) => {
                const index = state.districts.findIndex(({ id }) => id === res.id);
                state.districts[index] = res;
            });
            return res;
        }
        catch (error) { // eslint-disable-line @typescript-eslint/no-explicit-any
            // @ts-ignore
            throw error;
        }
    },
    deleteDistrict: async (district, { setState }) => {
        try {
            if (!district.isNew)
                await deleteDistrictApi(district);
            setState((state) => {
                state.districts = state.districts.filter(({ id }) => id !== district.id);
            });
        }
        catch (error) {
            // @ts-ignore
            throw error;
        }
    },
    getDistrictDevelopers: async ({ districtId }, { setState }) => {
        try {
            const { data: res } = await getDistrictDevelopersApi({ districtId });
            setState((state) => {
                state.district.developers = res;
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error;
        }
    },
    getDistrictImages: async ({ districtId }, { setState }) => {
        try {
            const { data: res } = await getDistrictImagesApi({ districtId });
            setState((state) => {
                state.district.images = res;
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error;
        }
    },
    getDistrictCompaniesAggregate: async ({ districtId, params }, { setState }) => {
        try {
            const { data: res } = await getDistrictCompaniesAggregate(districtId, params);
            setState((state) => {
                state.district.companiesAggregate = res.companies;
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error;
        }
    },
};
const initialStore = { ...initialState, ...actions };
export default create()(devtools(immer((set, get) => abortController(initialStore, set, get, 'Districts')), {
    name: 'Districts',
}));
